import { Box, Divider } from '@material-ui/core';
import { CardIndividualProps } from './CardIndividual';
import IndividualBenefitsResume from './IndividualBenefitsResume';
import IndividualCoveragesResume from './IndividualCoveragesResume';
import IndividualDeductiblesResume from './IndividualDeductiblesResume';

type Props = CardIndividualProps & {
  openDialog?: boolean;
};

const BodyResumeCard = ({
  coverageCatalogResumes,
  coverageCatalogs,
  moneyType,
  packageOption,
  unit,
  quotation,
  openDialog,
}: Props): JSX.Element => {
  return (
    <>
      <Box sx={{ marginTop: '10px' }}>
        <Divider />
      </Box>
      <Box sx={{ marginTop: '20px' }}>
        <IndividualCoveragesResume
          data-testid="individual-coverages-resume"
          coverageCatalogResumes={coverageCatalogResumes}
          coverageCatalogs={coverageCatalogs}
          packageOption={packageOption}
          moneyType={moneyType}
          unit={unit}
          quotation={quotation}
        />
      </Box>
      <Divider />
      <Box sx={{ marginTop: '20px' }}>
        <IndividualDeductiblesResume
          data-testid="individual-deductibles-resume"
          coverageCatalogResumes={coverageCatalogResumes}
          coverageCatalogs={coverageCatalogs}
          packageOption={packageOption}
          moneyType={moneyType}
          unit={unit}
          quotation={quotation}
        />
      </Box>
      <Divider />
      <Box sx={{ marginTop: '20px' }}>
        <IndividualBenefitsResume
          data-testid="individual-benefits-resume"
          coverageCatalogResumes={coverageCatalogResumes}
          coverageCatalogs={coverageCatalogs}
          packageOption={packageOption}
          moneyType={moneyType}
          unit={unit}
          quotation={quotation}
          openDialog={openDialog}
        />
      </Box>
    </>
  );
};

export default BodyResumeCard;
